/**
 * Format currency values for LLM consumption
 */
export const formatCurrency = (value: number, locale = 'en-GB', currency = 'GBP'): string => {
  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
  return formatter.format(value);
};

/**
 * Format percentage values
 */
export const formatPercentage = (value: number, decimals = 1): string => {
  const formatted = value.toFixed(decimals);
  const prefix = value >= 0 ? '+' : '';
  return `${prefix}${formatted}%`;
};
